import { Block, ControlPoint } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import FormikFocusError from "app/common/form/FormikFocusError";
import {
  formatMoney,
  getCurrentStaff,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisTreatmentAssign,
  isRoleTechician,
  isSalesConsultant,
  transformDate,
} from "app/common/LocalFunction";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";

import { Grid, Tab } from "@material-ui/core";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import PrintIcon from "@material-ui/icons/Print";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import Config, { VALIDATE_PAYMENT_TREATMENT } from "app/appConfig";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  PathModule,
  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME,
} from "app/common/LocalConst";
import { useStore } from "app/stores";
import { FormikConsumer, useFormikContext } from "formik";
import * as Yup from "yup";
import UncompletedServiceList from "./UncompletedServiceList";
import UncompletedServiceSearch from "./UncompletedServiceSearch";
import WarrantyServiceList from "./WarrantyServiceList";
import WarrantyServiceSearch from "./WarrantyServiceSearch";
import { toast } from "react-toastify";
import moment from "moment";
const UncompletedServicePopup = ({
  handleClose,
  open,
  onSubmit,
  initialValue,
  handleChangeFormSearchService,
  handleOpenConfirmAssign,
  handleConfirmAssignAndRenewPage,
  handleGetPatientOverviewById,
  handleCloseConfirmAssign,
  readOnly,
}) => {
  const {
    handleOpenPrintTreatmentPopup,
    setSelectedItem,
    handleSetConfirmError,
  } = useStore().patientManagementStore.serviceRequestItemStore;

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  const validationSchema = Yup.object({
    uncompletedRegisterServices: Yup.array()
      .of(
        Yup.object().shape({
          // room: Yup.object().nullable().required("Đây là trường bắt buộc"),
        }),
      )
      .nullable(),
    assigner: Yup.object().nullable().required("Đây là trường bắt buộc"),
    orderDate: Yup.date()
      .transform(function (_, originalValue) {
        if (!originalValue) return null;
        if (Array.isArray(originalValue) && originalValue.length >= 3) {
          return moment([
            originalValue[0],
            originalValue[1] - 1,
            originalValue[2],
            originalValue[3] || 0,
            originalValue[4] || 0,
            originalValue[5] || 0,
          ]).toDate();
        }
        return moment(originalValue).isValid()
          ? moment(originalValue).toDate()
          : originalValue;
      })
      .typeError("Ngày/Giờ chưa đúng định dạng!")
      .nullable()
      .required("Đây là trường bắt buộc")
      .test(
        "is-greater-or-equal",
        "Ngày điều trị phải lớn hơn hoặc bằng ngày đăng ký gần nhất",
        function (value) {
          if (!value) return true;
          const { uncompletedRegisterServices } = this.parent;

          let latestDate = null;

          if (
            uncompletedRegisterServices &&
            uncompletedRegisterServices.length > 0
          ) {
            uncompletedRegisterServices.forEach((item) => {
              let dStr = item.orderDate;
              if (dStr) {
                let d;
                if (Array.isArray(dStr) && dStr.length >= 3) {
                  d = moment([
                    dStr[0],
                    dStr[1] - 1,
                    dStr[2],
                    dStr[3] || 0,
                    dStr[4] || 0,
                    dStr[5] || 0,
                  ]);
                } else {
                  d = moment(dStr);
                }

                if (d.isValid()) {
                  if (!latestDate || d.isAfter(latestDate)) {
                    latestDate = d;
                  }
                }
              }
            });
          }

          if (latestDate) {
            let treatmentDate = moment(value);
            return treatmentDate.isSameOrAfter(latestDate, "minute");
          }

          return true;
        },
      ),
  });

  const defaultDepartment = useDefaultDepartment();
  const currentStaff = getCurrentStaff();

  const { currentTab, isLoading } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchService({
        ...initialValue,
        fromDate: null,
        toDate: null,
        departmentId: defaultDepartment?.id,
        department: defaultDepartment,
        patientId,
        orderDate: new Date(),
        assigner: currentStaff,
        unCompleted: true,
      });
    }
  }, [patientId, currentTab]);

  const canAssign =
    isAdmin() ||
    isRoleBranchManager() ||
    isSalesConsultant() ||
    isRoleCashier() ||
    isDoctor() ||
    isRoleTechician() ||
    isRoleChiefTechician();

  const handleAssign = async (values) => {
    await handleOpenConfirmAssign(values);
    await handleConfirmAssignAndRenewPage();
    if (patientId) {
      await handleGetPatientOverviewById(patientId);
    }
    handleCloseConfirmAssign();
  };

  const checkItemValid = (uncompletedRegisterServices) => {
    let message = "không đủ điều kiện";
    let item = uncompletedRegisterServices.find((sv) => {
      if (sv?.amountActuallyPaid !== 0) {
        const moneyToCollect =
          +sv?.totalBillPatientPaid + (+sv?.oldCredit || 0);
        const moneyToPay = +sv?.amountActuallyPaid + (+sv?.oldCredit || 0);

        if (
          sv?.service?.serviceTreatmentType ===
          SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
        ) {
          const maxAssignTreatmentTimes =
            ((moneyToCollect / moneyToPay) * sv?.totalTreatmentTimes || 0) -
            sv?.totalPerformedTimes;
          if (sv.currentVolumeTreated > sv?.totalTreatmentTimes) {
            message = "Số lượng chỉ định vượt mức số lượng";
            return sv;
          }
          if (sv.currentVolumeTreated > maxAssignTreatmentTimes) return sv;
        } else {
          const maxAssignTreatmentTimes = Math.floor(
            (moneyToCollect / moneyToPay) * sv?.totalTreatmentTimes || 0,
          );

          if (sv.totalPerformedTimes + 1 > maxAssignTreatmentTimes) return sv;
        }
      }
    });
    return {
      ...item,
      checkInvalid: item ? true : false,
      message,
    };
  };

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Các dịch vụ đã đăng ký chưa hoàn thành`}
      formik={{
        initialValues: {
          ...initialValue,
          isSubmittingHandle: false,
        },
        onSubmit: onSubmit,
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ values, isSubmitting, setFieldValue }) => {
        return (
          <FormikConsumer>
            {(formik) => (
              <div className="flex-center gap-1">
                <CommonButton className="btn-gray" onClick={handleClose}>
                  <Block className="mr-1" /> Đóng
                </CommonButton>

                {/* nút này là chỉ định và in */}
                {currentTab === 0 &&
                  !readOnly &&
                  canAssign &&
                  values?.uncompletedRegisterServices?.length > 0 && (
                    <CommonButton
                      className="btn-add"
                      disabled={isLoading}
                      style={{
                        backgroundColor: "#f16321",
                        color: "white",
                        marginRight: "4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={async () => {
                        if (isLoading) return;
                        const list = values?.uncompletedRegisterServices || [];

                        for (let i = 0; i < list.length; i++) {
                          const item = list[i];

                          if (
                            item?.service?.serviceTreatmentType ===
                            SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
                          ) {
                            if (
                              item.currentVolumeTreated === null ||
                              item.currentVolumeTreated === undefined ||
                              item.currentVolumeTreated === ""
                            ) {
                              toast.error(
                                `Vui lòng nhập số lượng điều trị cho dịch vụ Cc`,
                              );
                              return;
                            }

                            if (Number(item.currentVolumeTreated) <= 0) {
                              toast.error(`Số lượng điều trị phải lớn hơn 0`);
                              return;
                            }
                          }
                        }

                        const errors = await formik.validateForm();
                        formik.setTouched(
                          Object.keys(formik?.initialValues).reduce(
                            (acc, key) => {
                              acc[key] = true;
                              return acc;
                            },
                            {},
                          ),
                        );

                        if (Object.keys(errors).length === 0) {
                          if (VALIDATE_PAYMENT_TREATMENT) {
                            const itemInvalid = checkItemValid(
                              values.uncompletedRegisterServices,
                            );
                            if (itemInvalid?.checkInvalid) {
                              let checkServiceCc =
                                itemInvalid?.service?.serviceTreatmentType ===
                                SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME;

                              if (itemInvalid?.unLimited) {
                                handleSetConfirmError(
                                  `Dịch vụ ${itemInvalid?.service?.name} ${
                                    itemInvalid?.message
                                  } để được chỉ định!
  Tổng tiền cần thu: ${formatMoney(itemInvalid?.amountActuallyPaid || 0)}.
  Tổng tiền đã thu: ${formatMoney(itemInvalid?.totalBillPatientPaid || 0)}
  Tổng tiền khấu trừ từ LT cũ: ${formatMoney(itemInvalid?.oldCredit || 0)}
  Vui lòng thanh toán thêm để thực hiện dịch vụ này `,
                                );
                              } else {
                                handleSetConfirmError(
                                  `Dịch vụ ${itemInvalid?.service?.name} ${
                                    itemInvalid?.message
                                  } để được chỉ định!
  Tổng tiền cần thu: ${formatMoney(itemInvalid?.amountActuallyPaid || 0)}/${
    itemInvalid?.totalTreatmentTimes
  } ${
    checkServiceCc
      ? `${
          itemInvalid?.service?.soldUnit?.service?.soldUnit
            ? itemInvalid?.service?.soldUnit?.service?.soldUnit
            : "Cc"
        }`
      : "lần điều trị"
  }.
  
  Tổng tiền đã thu: ${formatMoney(itemInvalid?.totalBillPatientPaid || 0)}
  Tổng tiền khấu trừ từ LT cũ: ${formatMoney(itemInvalid?.oldCredit || 0)}
  Tổng số buổi đã thực hiện: ${itemInvalid?.totalPerformedTimes}
  Vui lòng thanh toán thêm để thực hiện dịch vụ này `,
                                );
                              }
                              return;
                            }
                          }
                          await handleAssign(values);
                          // cập nhật listSelectedItem để in luôn dịch vụ vừa chỉ định
                          if (values?.uncompletedRegisterServices?.length > 0) {
                            setSelectedItem(values.uncompletedRegisterServices);
                          }
                          handleOpenPrintTreatmentPopup();
                        }
                      }}
                    >
                      <AssignmentTurnedInIcon style={{ marginRight: 4 }} />
                      <PrintIcon style={{ marginRight: 4 }} />
                      Chỉ định và In phiếu
                    </CommonButton>
                  )}

                {/* nút này là chỉ định thôi */}
                {currentTab === 0 &&
                  !readOnly &&
                  canAssign &&
                  values?.uncompletedRegisterServices?.length > 0 && (
                    <CommonButton
                      className="btn-add"
                      disabled={isLoading}
                      onClick={async () => {
                        if (isLoading) return;
                        const list = values?.uncompletedRegisterServices || [];
                        for (let i = 0; i < list.length; i++) {
                          const item = list[i];

                          if (
                            item?.service?.serviceTreatmentType ===
                            SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
                          ) {
                            if (
                              item.currentVolumeTreated === null ||
                              item.currentVolumeTreated === undefined ||
                              item.currentVolumeTreated === ""
                            ) {
                              toast.error(
                                `Vui lòng nhập số lượng điều trị cho dịch vụ Cc`,
                              );
                              return;
                            }

                            if (Number(item.currentVolumeTreated) <= 0) {
                              toast.error(`Số lượng điều trị phải lớn hơn 0`);
                              return;
                            }
                          }
                        }
                        const errors = await formik.validateForm();
                        formik.setTouched(
                          Object.keys(formik?.initialValues).reduce(
                            (acc, key) => {
                              acc[key] = true;
                              return acc;
                            },
                            {},
                          ),
                        );

                        if (Object.keys(errors).length === 0) {
                          if (VALIDATE_PAYMENT_TREATMENT) {
                            const itemInvalid = checkItemValid(
                              values.uncompletedRegisterServices,
                            );
                            console.log("itemInvalid", itemInvalid);

                            if (itemInvalid?.checkInvalid) {
                              let checkServiceCc =
                                itemInvalid?.service?.serviceTreatmentType ===
                                SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME;
                              if (itemInvalid?.unLimited) {
                                handleSetConfirmError(
                                  `Dịch vụ ${itemInvalid?.service?.name} ${
                                    itemInvalid?.message
                                  } để được chỉ định!
  Tổng tiền cần thu: ${formatMoney(itemInvalid?.amountActuallyPaid || 0)}.
  Tổng tiền đã thu: ${formatMoney(itemInvalid?.totalBillPatientPaid || 0)}
  Tổng tiền khấu trừ từ LT cũ: ${formatMoney(itemInvalid?.oldCredit || 0)}
  Vui lòng thanh toán thêm để thực hiện dịch vụ này `,
                                );
                              } else {
                                handleSetConfirmError(
                                  `Dịch vụ ${itemInvalid?.service?.name} ${
                                    itemInvalid?.message
                                  } để được chỉ định!
  Tổng tiền cần thu: ${formatMoney(itemInvalid?.amountActuallyPaid || 0)}/${
    itemInvalid?.totalTreatmentTimes
  } ${
    checkServiceCc
      ? `${
          itemInvalid?.service?.soldUnit ? itemInvalid?.service?.soldUnit : "Cc"
        }`
      : "lần điều trị"
  }  .
  Tổng tiền đã thu: ${formatMoney(itemInvalid?.totalBillPatientPaid || 0)}
  Tổng tiền khấu trừ từ LT cũ: ${formatMoney(itemInvalid?.oldCredit || 0)}
  Tổng số buổi đã thực hiện: ${itemInvalid?.totalPerformedTimes}
  Vui lòng thanh toán thêm để thực hiện dịch vụ này `,
                                );
                              }
                              return;
                            }
                          }

                          await handleAssign(values);
                        }
                      }}
                    >
                      <ControlPoint className="mr-1" /> Chỉ định thực hiện
                    </CommonButton>
                  )}

                {currentTab === 1 &&
                  !readOnly &&
                  canAssign &&
                  values?.uncompletedRegisterServices?.length > 0 && (
                    <ButtonWarrantyService
                      formik={formik}
                      handleGetPatientOverviewById={
                        handleGetPatientOverviewById
                      }
                      patientId={patientId}
                    />
                  )}
              </div>
            )}
          </FormikConsumer>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <div className="w-100 pl-2 pr-2">
            <FormikFocusError />

            <ValueForm
              readOnly={readOnly}
              handleChangeFormSearchService={handleChangeFormSearchService}
              initialValue={initialValue}
              patientId={patientId}
            />
            <DialogConfirmError
              patientId={patientId}
              setFieldValue={setFieldValue}
            />
            <DialogError onSubmit={() => handleAssign(values)} />
          </div>
        );
      }}
    </PopupForm>
  );
};

const ButtonWarrantyService = observer(
  ({ formik, handleGetPatientOverviewById, patientId }) => {
    const { pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate } =
      useStore().patientManagementStore.serviceRequestItemStore;
    const { isLoading } = useStore().patientManagementStore.uncompletedRegisterServiceStore;
    const { handleConfirmAssignWarrantyService, handleCloseConfirmAssign } =
      useStore().patientManagementStore.uncompletedRegisterServiceStore;
    const handleAssignWarranty = async (values) => {
      await handleConfirmAssignWarrantyService(values);
      handleCloseConfirmAssign();
      if (patientId) {
        await handleGetPatientOverviewById(patientId);
      }
      await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
    };

    const { values } = useFormikContext();
    return (
      <CommonButton
        className="btn-add"
        disabled={isLoading}
        onClick={async () => {
          if (isLoading) return;
          const errors = await formik.validateForm();
          formik.setTouched(
            Object.keys(formik?.initialValues).reduce((acc, key) => {
              acc[key] = true;
              return acc;
            }, {}),
          );

          if (Object.keys(errors).length === 0) {
            await handleAssignWarranty(values);
          }
        }}
      >
        <ControlPoint className="mr-1" /> Bảo hành
      </CommonButton>
    );
  },
);

const TabTreatment = observer(({ readOnly }) => {
  return (
    <>
      <UncompletedServiceSearch readOnly={readOnly} />
      <UncompletedServiceList readOnly={readOnly} />
    </>
  );
});

const TabWarranty = observer(({ readOnly }) => {
  return (
    <>
      <WarrantyServiceSearch readOnly={readOnly} />
      <WarrantyServiceList readOnly={readOnly} />
    </>
  );
});

const ValueForm = observer(({ readOnly }) => {
  const { currentTab, setCurrentTab } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;

  const TAB_LIST = [
    {
      tabName: "Điều trị",
      content: (
        <>
          <TabTreatment readOnly={readOnly} />
        </>
      ),
      value: 0,
    },
    {
      tabName: "Bảo hành",
      content: (
        <>
          <TabWarranty />
        </>
      ),
      value: 1,
    },
  ];

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabContext value={currentTab}>
          <TabList
            className="tabs-container-white tab-custom-fee"
            style={{
              paddingLeft: "0",
              paddingRight: "0",
            }}
            onChange={(_, newTabIndex) => {
              setCurrentTab(newTabIndex);
            }}
            value={currentTab}
          >
            {TAB_LIST.map((tab, index) => (
              <Tab
                key={index}
                className={`item-tabs  ${
                  index === currentTab ? "item-tabs-active" : ""
                }`}
                label={tab.tabName}
                value={index}
              />
            ))}
          </TabList>
          {TAB_LIST.map((tab, index) => (
            <TabPanel
              component="section"
              className="p-0"
              key={tab.value}
              value={index}
            >
              {tab.content}
            </TabPanel>
          ))}
        </TabContext>
      </Grid>
    </Grid>
  );
});

const DialogConfirmError = observer(({ patientId, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            setFieldValue("orderDate", new Date());
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patientId}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Đăng ký thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const DialogError = observer(({ onSubmit }) => {
  const treatmentAssignPermission = isRoleHisTreatmentAssign();
  const { openConfirmError, handleCloseConfirmError } =
    useStore().patientManagementStore.serviceRequestItemStore;
  return (
    <>
      {!!openConfirmError && (
        <ConfirmPopup
          {...(treatmentAssignPermission
            ? {
                onConfirm: () => {
                  onSubmit();
                  handleCloseConfirmError(null);
                },
                textConfirm: "Duyệt chỉ định",
              }
            : { isNotAPromise: true, hideConfirm: true })}
          open={!!openConfirmError}
          onClose={() => {
            handleCloseConfirmError(null);
          }}
          text={openConfirmError}
          textClose={"Quay lại"}
          title="Chỉ định thất bại"
        />
      )}
    </>
  );
});
export default memo(observer(UncompletedServicePopup));
